import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  private createParentNode(key: string, label: string, data: string, group: string, children: any[]) {
    return {
      key,
      label: `filters.${label}`,
      data,
      group,
      ignore: true,
      children
    };
  }
  
  private createChildNode(key: string, group: string, data: string | null, label: string, parentData?: string, aggregated?: boolean) {
    const node: any = {
      key,
      group,
      data,
      label
    };
    
    if (parentData) {
      node.parentData = parentData;
    }
    
    if (aggregated) {
      node.aggregated = true;
    }
    
    return node;
  }

  getStatus() {
    // Format status
    const formatChildren = [
      this.createChildNode('1-1', 'statusFormat', 'VALID', 'filters.valid'),
      this.createChildNode('1-2', 'statusFormat', 'INVALID', 'filters.invalid'),
      this.createChildNode('1-3', 'statusFormat', 'AWAITING_MEDIA', 'filters.awaitingMedia')
    ];

    // Changes requested children
    const changesRequestedChildren = [
      this.createChildNode('2-4-1', 'editorialCharter', 'ATTRIBUTES_KO_TEMP', 'filters.missionAttributes', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-2', 'editorialCharter', 'CATEGORY_KO_TEMP', 'filters.nonCompliantCategorisation', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-3', 'editorialCharter', 'DESCRIPTION_KO_TEMP', 'filters.nonCompliantDescription', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-4', 'editorialCharter', 'MEDIA_KO_TEMP', 'filters.nonCompliantImage', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-5', 'editorialCharter', 'TITLE_KO_TEMP', 'filters.nonCompliantTitle', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-6', 'editorialCharter', 'OTHER_KO_TEMP', 'filters.otherReasonsTitle', 'CHANGES_REQUESTED', true),
      this.createChildNode('2-4-7', 'editorialCharter', 'DESCRIPTION_LENGTH_KO_TEMP', 'filters.descriptionLengthKo', 'CHANGES_REQUESTED', true),
    ];

    // Rejected children
    const rejectedChildren = [
      this.createChildNode('2-5-1', 'editorialCharter', 'DUPLICATE_EAN', 'filters.duplicationEan', 'REJECTED', true),
      this.createChildNode('2-5-2', 'editorialCharter', 'EDITORIAL_KO', 'filters.NonCompliantEditorialLine', 'REJECTED', true)
    ];

    // Editorial charter group
    const editorialCharterChildren = [
      this.createChildNode('2-1', 'editorialCharter', null, 'filters.notApplicable', 'NOT_APPLICABLE', true),
      this.createChildNode('2-2', 'editorialCharter', null, 'filters.new', 'NEW', true),
      this.createChildNode('2-3', 'editorialCharter', null, 'filters.waitingForVerification', 'TO_BE_VERIFIED', true),
      {
        ...this.createParentNode('2-4', 'editorialCharterStatus', 'CHANGES_REQUESTED', 'editorialCharter', changesRequestedChildren),
        label: 'filters.changeRequired'
      },
      {
        ...this.createParentNode('2-5', 'editorialCharterStatus', 'REJECTED', 'editorialCharter', rejectedChildren),
        label: 'filters.defivitiveRfusal'
      },
      this.createChildNode('2-6', 'editorialCharter', null, 'filters.accepted', 'ACCEPTED', true)
    ];

    // Publication status
    const publicationChildren = [
      this.createChildNode('3-1', 'publicationStatus', 'SYNCHRONIZED', 'filters.publishable'),
      this.createChildNode('3-2', 'publicationStatus', 'NOT_SYNCHRONIZED', 'filters.notPublishable')
    ];

    return [
      this.createParentNode('1', 'formatStatus', 'format', 'statusFormat', formatChildren),
      this.createParentNode('2', 'editorialCharterStatus', 'EDIATORIAL_CHARTER', 'editorialCharter', editorialCharterChildren),
      this.createParentNode('3', 'publicationStatus', 'PUBLICATION', 'publicationStatus', publicationChildren)
    ];
  }
}
